<template>
  <div class="mt-0 pt-0">
    <v-card class="elevation-2" outlined>
      <v-card-title class="d-flex flex-wrap align-center" style="gap: 12px;">
        <div>
          
          <div class="text-h6">Reporte de contactos registrados</div>
        </div>
        <v-spacer></v-spacer>
        <v-chip color="deep-green lighten-4" class="deep-purple--text text--darken-4" small>
          Total contactos: {{ contactos.length }}
        </v-chip>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-row dense class="mb-2">
          <v-col cols="12" sm="4" md="2" lg="2" xl="1">
            <v-btn @click="$router.back()" outlined color="green"> <v-icon>mdi-arrow-left</v-icon> Volver</v-btn>
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-text-field
              v-model="desde"
              type="date"
              label="Desde"
              dense
              outlined
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-text-field
              v-model="hasta"
              type="date"
              label="Hasta"
              dense
              outlined
              hide-details
            />
          </v-col> 
          <v-col cols="12" sm="3" md="6" class="d-flex align-center" style="gap: 8px;">
            <v-btn color="blue" dark @click="listar">
              <v-icon left>mdi-refresh</v-icon>
              Listar
            </v-btn> 
          </v-col>
        </v-row>

        <v-progress-linear v-if="loading" indeterminate color="green" class="mb-3" />

        <v-divider></v-divider>

        <div class="mb-4">
          <v-row>
            <v-col
              v-for="item in resumenCards"
              :key="item.titulo"
              cols="12"
              sm="6"
              md="3"
            >
              <v-sheet outlined rounded :class="['pa-3 fill-height metric-card', `metric-card-${item.color}`]">
                <div class="text-caption grey--text text--darken-1">{{ item.titulo }}</div>
                <div class="text-subtitle-1 font-weight-medium text-truncate">{{ item.nombre }}</div>
                <div class="d-flex align-center mt-1">
                  <v-chip small color="green lighten-5" class="green--text text--darken-3">
                    {{ item.cantidad }} contactos
                  </v-chip>
                  <span class="text-caption ml-2 grey--text text--darken-1">{{ item.porcentaje }}%</span>
                </div>
              </v-sheet>
            </v-col>
          </v-row>

          <v-row class="mt-1">
            <v-col cols="12" md="5">
              <v-sheet outlined rounded class="pa-3 fill-height summary-panel summary-panel-podium">
                <div class="text-subtitle-2 font-weight-bold mb-3">Podium de asesores</div>
                <v-row dense align="end">
                  <v-col
                    v-for="asesor in podiumAsesores"
                    :key="asesor.id"
                    cols="12"
                    sm="4"
                  >
                    <div :class="['podium-item pa-3 text-center', `podium-${asesor.posicion}`]">
                      <v-avatar :color="podiumColor(asesor.posicion - 1)" size="40" class="white--text mb-2">
                        {{ asesor.posicion }}
                      </v-avatar>
                      <div class="text-body-2 font-weight-medium asesor-name">{{ asesor.nombre }}</div>
                      <div class="text-h6 font-weight-bold">{{ asesor.cantidad }}</div>
                      <div class="text-caption">{{ asesor.porcentaje }}%</div>
                    </div>
                  </v-col>
                </v-row>
                <div v-if="!reporte.podium.length" class="text-caption grey--text">
                  No hay datos suficientes para mostrar el podium.
                </div>
              </v-sheet>
            </v-col> 

            <v-col cols="12" md="7">
              <v-sheet outlined rounded class="pa-3 fill-height summary-panel summary-panel-ranking">
                <div class="text-subtitle-2 font-weight-bold mb-2">Contactos por asesor</div>
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th>Asesor</th>
                      <th class="text-right">Cantidad</th>
                      <th class="text-right">%</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="asesor in reporte.asesores" :key="asesor.id">
                      <td>{{ asesor.nombre }}</td>
                      <td class="text-right font-weight-medium">{{ asesor.cantidad }}</td>
                      <td class="text-right">{{ asesor.porcentaje }}%</td>
                    </tr>
                    <tr v-if="!reporte.asesores.length">
                      <td colspan="3" class="text-center grey--text">Sin datos</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-sheet>
            </v-col>
          </v-row>

          <v-row class="mt-1">
            <v-col
              v-for="tabla in resumenTablas"
              :key="tabla.titulo"
              cols="12"
              md="4"
            >
              <v-sheet outlined rounded :class="['pa-3 fill-height summary-panel', tabla.color]">
                <div class="text-subtitle-2 font-weight-bold mb-2">{{ tabla.titulo }}</div>
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th>{{ tabla.columna }}</th>
                      <th class="text-right">Cantidad</th>
                      <th class="text-right">%</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in tabla.items" :key="item.id">
                      <td>{{ item.nombre }}</td>
                      <td class="text-right font-weight-medium">{{ item.cantidad }}</td>
                      <td class="text-right">{{ item.porcentaje }}%</td>
                    </tr>
                    <tr v-if="!tabla.items.length">
                      <td colspan="3" class="text-center grey--text">Sin datos</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-sheet>
            </v-col>
          </v-row>
        </div>

        <h2 class="text-center">Detalle de contactos registrados</h2>

        <v-data-table
          :headers="xheaders"
          :items="filteredContactos"
          :loading="loading"
          :items-per-page="50" 
          dense
          class="elevation-1"
          no-data-text="No hay contactos para mostrar"
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table" />
          </template>
          <template v-slot:[`item.nombre_completo`]="{ item }">
            <span> {{ item.nombres }} {{ item.apellidos }} </span>
          </template>
          <template v-slot:[`item.fecha_de_contacto`]="{ item }">
            <span> {{ parseFecha(item.fecha_de_contacto) }} </span>
          </template> 
        </v-data-table>
      </v-card-text>
    </v-card>

  </div>
</template>

<script> 
  import { headers_rep, getContactos } from './utils';
  import { reportes_contactos } from './reporte_contactos'

  export default {
    components: { 
    },
    data() {
      return {
        loading: false,
        xheaders: headers_rep(),
        contactos: [],
        search: '',
        // desde: (() => { const d = new Date(); d.setDate(d.getDate() - 30); return d.toISOString().slice(0, 10); })(),
        desde: (() => { const d = new Date(); d.setDate(1); return d.toISOString().slice(0, 10); })(),
        hasta: (() => { const d = new Date(); d.setDate(d.getDate() + 1); return d.toISOString().slice(0, 10); })(),
      };
    },
    computed: {
      reporte() {
        return reportes_contactos(this.contactos);
      },
      podiumAsesores() {
        const podium = this.reporte.podium.map((asesor, index) => ({
          ...asesor,
          posicion: index + 1,
        }));
        if (podium.length === 3) return [podium[1], podium[0], podium[2]];
        return podium;
      },
      resumenCards() {
        const destacados = this.reporte.destacados;
        return [
          this.cardResumen('Área con más contactos', destacados.area, 'green'),
          this.cardResumen('Origen principal', destacados.origen, 'blue'),
          this.cardResumen('Programa más consultado', destacados.programa, 'amber'),
          this.cardResumen('Día con más registros', destacados.dia, 'purple'),
        ];
      },
      resumenTablas() {
        return [
          { titulo: 'Áreas de interés', columna: 'Área', items: this.reporte.areas.slice(0, 8), color: 'summary-panel-green' },
          { titulo: 'Orígenes', columna: 'Origen', items: this.reporte.origenes.slice(0, 8), color: 'summary-panel-blue' },
          { titulo: 'Programas de interés', columna: 'Programa', items: this.reporte.programas.slice(0, 8), color: 'summary-panel-amber' },
          { titulo: 'Profesiones', columna: 'Profesión', items: this.reporte.profesiones.slice(0, 8), color: 'summary-panel-purple' },
          { titulo: 'Estados', columna: 'Estado', items: this.reporte.estados.slice(0, 8), color: 'summary-panel-teal' },
          { titulo: 'Días con más contactos', columna: 'Fecha', items: this.reporte.dias.slice(0, 8), color: 'summary-panel-slate' },
        ];
      },
      filteredContactos() {
        if(!this.search) return this.contactos;
        const q = this.search.toLowerCase();
        return this.contactos.filter(c =>
          Object.values(c).some(v => String(v).toLowerCase().includes(q))
        );
      }
    },
    methods: {
      cardResumen(titulo, item, color) {
        return {
          titulo,
          nombre: item ? item.nombre : 'Sin datos',
          cantidad: item ? item.cantidad : 0,
          porcentaje: item ? item.porcentaje : 0,
          color,
        };
      },
      podiumColor(index) {
        return ['amber darken-2', 'blue-grey lighten-1', 'deep-orange lighten-1'][index] || 'green';
      },
      async listar() {
        const q = { } 

        this.loading = true;
        if(this.desde) q.desde = this.desde+'T00:00:00Z';
        if(this.hasta) q.hasta = this.hasta+'T23:59:00Z';
        const res = await getContactos(q);
        this.loading = false;

        if(res && res.error){
          this.$root.$notify.show(res.error, { color: 'red', x: 'right' });
        }else if(res){
          this.contactos = res;
          // this.$root.$notify.show('registrado :)', { color: 'green', x: 'right' });
        }else{
          this.$root.$notify.show('algo salio mal :)', { color: 'red', x: 'right' });
        }
        
      }, 
      parseFecha(f){
        if(!f) return '';
        const fs = f.split('T')[0].split('-')
        return `${fs[2]}/${fs[1]}/${fs[0]}`
      }
    },
    mounted() {
      this.listar();
    },
  };
</script>

<style scoped>
.metric-card,
.summary-panel {
  border-color: rgba(0, 0, 0, 0.08) !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.metric-card-green {
  background: linear-gradient(135deg, #f3fbf6 0%, #e8f5ee 100%);
}

.metric-card-blue {
  background: linear-gradient(135deg, #f2f7fc 0%, #e6f0f8 100%);
}

.metric-card-amber {
  background: linear-gradient(135deg, #fffaf0 0%, #f8edd2 100%);
}

.metric-card-purple {
  background: linear-gradient(135deg, #f8f5fb 0%, #eee7f6 100%);
}

.summary-panel-podium {
  background: linear-gradient(135deg, #fffdf6 0%, #f5efe0 100%);
}

.summary-panel-ranking {
  background: linear-gradient(135deg, #f6faf8 0%, #edf5f1 100%);
}

.summary-panel-green {
  background: linear-gradient(135deg, #f7fcf8 0%, #edf7f0 100%);
}

.summary-panel-blue {
  background: linear-gradient(135deg, #f6faff 0%, #edf4fb 100%);
}

.summary-panel-amber {
  background: linear-gradient(135deg, #fffaf2 0%, #f8f0dd 100%);
}

.summary-panel-purple {
  background: linear-gradient(135deg, #fbf8fe 0%, #f1ebf8 100%);
}

.summary-panel-teal {
  background: linear-gradient(135deg, #f4fbfa 0%, #e8f5f2 100%);
}

.summary-panel-slate {
  background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);
}

.podium-item {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.58);
}

.podium-1 {
  min-height: 170px;
}

.podium-2 {
  min-height: 145px;
}

.podium-3 {
  min-height: 125px;
}

.asesor-name {
  min-height: 40px;
}
</style>
